import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const subheader: SugarElementInfo = {
    name: "subheader",
    availableChildren: { type: AvailableChildrenType.Any },
};
